import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

const SinglePrice = (props) => {
  const { itemClass, title, value, description, features, btnText } = props;
  return (
    <div className={itemClass ? itemClass : 'it-price-item'}>
      <div className="it-price-head">
        <h4 className="it-price-title mb-15">{title ? title : 'Basic Plan'}</h4>
        <span className="it-price-value">
          ${value}
          <i>/Month</i>
        </span>
        <div className="it-price-text">
          <p>
            {description
              ? description
              : ' Health and medical is a encompasses a wide range of topics related to health'}
          </p>
        </div>
      </div>
      <div className="it-price-body mb-50">
        <div className="it-price-list">
          <ul>
            {features.map((feature, index) => (
              <li className={feature?.featureClass} key={feature.id}>
                <i className="flaticon-check-mark"></i>
                {feature.featureTitle}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="it-price-button">
        <Link className="it-btn-theme" to="/price">
          <Button btnText={btnText ? btnText : 'Select Plan'} />
        </Link>
      </div>
    </div>
  );
};

export default SinglePrice;
